<template>
  <div class="penangkap-galat">
    <div v-if="galat" class="galat-panel">
      <div class="galat-panel__kotak">
        <i class="bi bi-exclamation-octagon-fill galat-panel__ikon"></i>

        <h2 class="galat-panel__judul">Halaman ini gagal ditampilkan.</h2>

        <p class="galat-panel__teks">
          Bukan kesalahan Anda. Salin kotak di bawah dan kirimkan supaya
          penyebabnya bisa diperbaiki.
        </p>

        <pre class="galat-panel__pesan">{{ ringkasan }}</pre>

        <div class="galat-panel__aksi">
          <button type="button" class="ui-btn ui-btn--primary" @click="coba">
            <i class="bi bi-arrow-clockwise"></i> Coba lagi
          </button>
          <button type="button" class="ui-btn ui-btn--secondary" @click="salin">
            <i class="bi bi-clipboard"></i> {{ tersalin ? 'Tersalin' : 'Salin pesan' }}
          </button>
        </div>
      </div>
    </div>

    <slot v-else />
  </div>
</template>

<script>
export default {
  name: 'PenangkapGalat',

  data() {
    return {
      galat: null,
      jejak: '',
      dari: '',
      tersalin: false,
    };
  },

  computed: {
    ringkasan() {
      return [
        'Halaman : ' + (this.$route?.fullPath || '-'),
        'Saat    : ' + (this.dari || '-'),
        'Pesan   : ' + (this.galat?.message || String(this.galat)),
        '',
        (this.jejak || '').split('\n').slice(0, 6).join('\n'),
      ].join('\n');
    },
  },

  watch: {
    /*
     * Berpindah halaman membersihkan galat.
     * Tanpa ini, satu halaman yang rusak akan menahan pesan galatnya di
     * layar selamanya — termasuk saat pengguna sudah pindah ke halaman lain
     * yang baik-baik saja.
     */
    '$route.fullPath'() {
      this.bersihkan();
    },
  },

  errorCaptured(err, instance, info) {
    this.galat = err;
    this.jejak = err?.stack || '';
    this.dari = info || '';

    // false menghentikan penyebaran galat ke atas, sehingga sisa panel
    // (bilah sisi, kepala halaman) tetap hidup dan bisa dipakai berpindah.
    return false;
  },

  methods: {
    bersihkan() {
      this.galat = null;
      this.jejak = '';
      this.dari = '';
      this.tersalin = false;
    },

    coba() {
      this.bersihkan();
    },

    async salin() {
      try {
        await navigator.clipboard.writeText(this.ringkasan);
        this.tersalin = true;
        setTimeout(() => { this.tersalin = false; }, 2000);
      } catch (e) {
        // Papan klip bisa ditolak peramban. Teksnya tetap terlihat di layar
        // dan bisa disalin dengan tangan, jadi tidak ada yang hilang.
      }
    },
  },
};
</script>

<style scoped>
.galat-panel {
  display: flex;
  justify-content: center;
  padding: 2rem 1rem;
}

.galat-panel__kotak {
  max-width: 640px;
  width: 100%;
  padding: 1.75rem;
  border-radius: 14px;
  background: var(--bg-surface, #fff);
  border: 1px solid rgba(220, 38, 38, 0.25);
}

.galat-panel__ikon {
  font-size: 1.75rem;
  color: #b91c1c;
}

.galat-panel__judul {
  margin: 0.75rem 0 0.5rem;
  font-size: 1.15rem;
  font-weight: 700;
}

.galat-panel__teks {
  margin: 0 0 1rem;
  font-size: 0.92rem;
  line-height: 1.6;
  color: var(--text-secondary, #6b7280);
}

.galat-panel__pesan {
  margin: 0 0 1.25rem;
  padding: 0.85rem;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.05);
  font-size: 0.82rem;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 240px;
  overflow: auto;
}

.galat-panel__aksi {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
</style>
